import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@paypalcorp/pp-react';
import {
  PARTNERS_TITLE,
  MARKETPLACES_TITLE,
  CHECKOUT
} from '../../../lib/constants';
import {
  recordIntent,
  productToRPSMapping
} from '../../../lib/appcenterIntent';
import {
  fireDetailsPageComponentFailureFpti,
  parseData
} from '../../../lib/helpers';

const DetailsHeader = ({
  componentContent = {},
  handleClickFPTI,
  fptiImpression,
  location = {},
  app = {}
}) => {
  const { title, subtitle, button, appIcon, toolKey } = componentContent;

  let buttonItems = {};

  if (button) {
    buttonItems = parseData(button)[0];
  }
  let source = '';
  let medium = '';
  useEffect(() => {
    if (typeof document !== 'undefined') {
      const url = document.location.href;
      source = new URL(url).searchParams.get('utm_source');
      medium = new URL(url).searchParams.get('utm_medium');
    }
    if (source && medium) {
      const fptiObj = { utm_source: source, utm_medium: medium };
      fptiImpression(fptiObj);
    }
  }, []);

  const {
    text: buttonText,
    url: buttonUrl,
    subText: buttonSubtext
  } = buttonItems;

  let appIconItems = {};

  if (appIcon) {
    appIconItems = parseData(appIcon)[0];
  }

  const { url: imageURL } = appIconItems;

  if (!title || !subtitle || !buttonText || !buttonUrl || !imageURL) {
    fireDetailsPageComponentFailureFpti({
      data: { title, subtitle, buttonText, buttonUrl, imageURL },
      componentName: 'DetailsPhotoSection',
      fptiImpression
    });
    return null;
  }
  const locationValue = location.pathname ? location.pathname.split('/') : [];
  const locationCategory =
    locationValue.length !== 0 ? locationValue[locationValue.length - 2] : '';
  const partnerMarket =
    locationCategory === PARTNERS_TITLE ||
    locationCategory === MARKETPLACES_TITLE;
  const ctaRedirect = url => {
    if (source && medium && url) {
      let divider = '?';
      let urlQueryParams = new URL(url).search;
      if (urlQueryParams) {
        divider = '&';
      }
      window.location =
        url + `${divider}utm_source=${source}&utm_medium=${medium}`;
    } else {
      window.location = url;
    }
  };
  const handleClick = () => {
    handleClickFPTI('get_started');
    if (productToRPSMapping[toolKey]) {
      rpsRecordIntent(buttonUrl);
    } else if (toolKey === CHECKOUT) {
      handleCheckoutCase();
    } else {
      ctaRedirect(buttonUrl);
    }
  };
  const rpsRecordIntent = url => {
    recordIntent({
      csrf: app.csrf,
      productArr: [productToRPSMapping[toolKey]]
    }).finally(() => {
      ctaRedirect(url);
    });
  };

  const handleCheckoutCase = () => {
    const htmlElement = document.querySelector('#details-section-header');
    window.scrollTo(0, (htmlElement || {}).offsetTop);
  };

  return (
    <section id="details-header">
      <div className="details-header-container">
        <div className="container-one">
          <div
            className="details-header-image"
            style={{
              background: `url(${imageURL}) center center no-repeat`,
              backgroundSize: partnerMarket ? '100%' : '80%',
              ...(partnerMarket && { border: '0' })
            }}
          ></div>
        </div>
        <div className="container-two">
          <h1 dangerouslySetInnerHTML={{ __html: title }}></h1>
          <p dangerouslySetInnerHTML={{ __html: subtitle }}></p>
        </div>
        <div className="container-three">
          <Button onClick={handleClick}>{buttonText}</Button>
          {buttonSubtext && <p> {buttonSubtext} </p>}
        </div>
      </div>
    </section>
  );
};

DetailsHeader.propTypes = {
  componentContent: PropTypes.object,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  imageURL: PropTypes.string,
  buttonUrl: PropTypes.string,
  buttonText: PropTypes.string,
  buttonSubtext: PropTypes.string,
  app: PropTypes.object,
  handleClickFPTI: PropTypes.func,
  location: PropTypes.object,
  fptiImpression: PropTypes.func.isRequired,
  toolName: PropTypes.string
};

export default DetailsHeader;
